export default {
  apiKey: 'AIzaSyAzksSg63DLOF4qi8YDB8VQTvxarDzwZkA',
  authDomain: 'ngapp5-dev.firebaseapp.com',
  databaseURL: 'https://ngapp5-dev.firebaseio.com',
  projectId: 'ngapp5-dev',
  storageBucket: 'ngapp5-dev.appspot.com',
  messagingSenderId: '116584503757',
  appId: '1:116584503757:web:c825aaa79811459dcb8c84',
  reCaptchaKey: '6LedxTclAAAAAOnvj-LT4Pqs0hX3IACCuS6BEQiH'
}
